<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<m-modal
    #modal
    [title]="'Chose start and end date'"
>
    <ng-container body>
        @if (dateForm) {
            <form [formGroup]="dateForm">
                <div class="form__fields">
                    <!--region Start at-->
                    <div class="form__field grid">
                        <label
                            class="grid__item-4"
                            for="inputTeamArrival"
                        >
                            {{ "endSiteDialog.teamArrival" | translate }}
                        </label>
                        <div class="grid__item-8">
                            <div (click)="inputTeamArrival.showPicker()">
                                <input
                                    class="input--text"
                                    id="inputTeamArrival"
                                    #inputTeamArrival
                                    [class.input--text-has-error]="
                                        dateForm.get('teamArrival')?.invalid && dateForm.get('teamArrival')?.touched
                                    "
                                    formControlName="teamArrival"
                                    placeholder=""
                                    type="datetime-local"
                                />
                            </div>
                            @if (dateForm.get("teamArrival")?.invalid && dateForm.get("teamArrival")?.touched) {
                                <div class="error-message">
                                    @if (dateForm.get("teamArrival")?.errors?.["arrivalNotBeforeDeparture"]) {
                                        <p class="form-validation-error">
                                            {{ "endSiteDialog.arrivalMustBeBeforeDeparture" | translate }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <!--endregion-->

                    <!--region End at-->
                    <div class="form__field grid">
                        <label
                            class="grid__item-4"
                            for="end"
                        >
                            {{ "endSiteDialog.teamDeparture" | translate }}
                        </label>
                        <div class="grid__item-8">
                            <div (click)="inputTeamDeparture.showPicker()">
                                <input
                                    class="input--text"
                                    id="end"
                                    #inputTeamDeparture
                                    [class.input--text-has-error]="
                                        dateForm.get('teamDeparture')?.invalid && dateForm.get('teamDeparture')?.touched
                                    "
                                    formControlName="teamDeparture"
                                    placeholder=""
                                    type="datetime-local"
                                />
                            </div>
                            @if (dateForm.get("teamDeparture")?.invalid && dateForm.get("teamDeparture")?.touched) {
                                <div>
                                    @if (dateForm.get("teamDeparture")?.errors?.["departureNotAfterArrival"]) {
                                        <p class="form-validation-error">
                                            {{ "endSiteDialog.departureMustBeAfterArrival" | translate }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <!--endregion-->
                </div>
            </form>
        }
    </ng-container>

    <ng-container
        #footer
        footer
    >
        @if (dateForm) {
            <div class="flex align-items-center justify-content-between gap-8">
                <button
                    class="btn"
                    (click)="modal.closeModal()"
                    type="button"
                >
                    {{ "endSiteDialog.cancel" | translate }}
                </button>

                <button
                    class="btn--yellow ml-auto"
                    [disabled]="!dateForm.valid"
                    (click)="onSubmit()"
                    type="button"
                >
                    {{ "endSiteDialog.finish" | translate }}
                </button>
            </div>
        }
    </ng-container>
</m-modal>
